/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiErrorResponse,
  PlanResponse,
  PlanSelectionRequest,
  PromoCodeRedemptionRequest,
  UserAccessResponse,
} from '../models/index';
import {
    ApiErrorResponseFromJSON,
    ApiErrorResponseToJSON,
    PlanResponseFromJSON,
    PlanResponseToJSON,
    PlanSelectionRequestFromJSON,
    PlanSelectionRequestToJSON,
    PromoCodeRedemptionRequestFromJSON,
    PromoCodeRedemptionRequestToJSON,
    UserAccessResponseFromJSON,
    UserAccessResponseToJSON,
} from '../models/index';

export interface RedeemMyPromoCodeRequest {
    promoCodeRedemptionRequest: PromoCodeRedemptionRequest;
}

export interface SelectMyPlanRequest {
    planSelectionRequest: PlanSelectionRequest;
}

/**
 * AccessApi - interface
 * 
 * @export
 * @interface AccessApiInterface
 */
export interface AccessApiInterface {
    /**
     * 
     * @summary Get the current user\'s effective roles, capabilities, plan, and limits
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApiInterface
     */
    getMyAccessRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserAccessResponse>>;

    /**
     * Get the current user\'s effective roles, capabilities, plan, and limits
     */
    getMyAccess(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserAccessResponse>;

    /**
     * 
     * @summary List access plans visible to the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApiInterface
     */
    listMyPlansRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PlanResponse>>>;

    /**
     * List access plans visible to the current user
     */
    listMyPlans(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PlanResponse>>;

    /**
     * 
     * @summary Redeem a promo code for the current user
     * @param {PromoCodeRedemptionRequest} promoCodeRedemptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApiInterface
     */
    redeemMyPromoCodeRaw(requestParameters: RedeemMyPromoCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserAccessResponse>>;

    /**
     * Redeem a promo code for the current user
     */
    redeemMyPromoCode(requestParameters: RedeemMyPromoCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserAccessResponse>;

    /**
     * 
     * @summary Select a self-service access plan for the current user
     * @param {PlanSelectionRequest} planSelectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApiInterface
     */
    selectMyPlanRaw(requestParameters: SelectMyPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserAccessResponse>>;

    /**
     * Select a self-service access plan for the current user
     */
    selectMyPlan(requestParameters: SelectMyPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserAccessResponse>;

}

/**
 * 
 */
export class AccessApi extends runtime.BaseAPI implements AccessApiInterface {

    /**
     * Get the current user\'s effective roles, capabilities, plan, and limits
     */
    async getMyAccessRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserAccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/me/access`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserAccessResponseFromJSON(jsonValue));
    }

    /**
     * Get the current user\'s effective roles, capabilities, plan, and limits
     */
    async getMyAccess(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserAccessResponse> {
        const response = await this.getMyAccessRaw(initOverrides);
        return await response.value();
    }

    /**
     * List access plans visible to the current user
     */
    async listMyPlansRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PlanResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/me/plans`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PlanResponseFromJSON));
    }

    /**
     * List access plans visible to the current user
     */
    async listMyPlans(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PlanResponse>> {
        const response = await this.listMyPlansRaw(initOverrides);
        return await response.value();
    }

    /**
     * Redeem a promo code for the current user
     */
    async redeemMyPromoCodeRaw(requestParameters: RedeemMyPromoCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserAccessResponse>> {
        if (requestParameters['promoCodeRedemptionRequest'] == null) {
            throw new runtime.RequiredError(
                'promoCodeRedemptionRequest',
                'Required parameter "promoCodeRedemptionRequest" was null or undefined when calling redeemMyPromoCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/me/promo-codes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PromoCodeRedemptionRequestToJSON(requestParameters['promoCodeRedemptionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserAccessResponseFromJSON(jsonValue));
    }

    /**
     * Redeem a promo code for the current user
     */
    async redeemMyPromoCode(requestParameters: RedeemMyPromoCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserAccessResponse> {
        const response = await this.redeemMyPromoCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Select a self-service access plan for the current user
     */
    async selectMyPlanRaw(requestParameters: SelectMyPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserAccessResponse>> {
        if (requestParameters['planSelectionRequest'] == null) {
            throw new runtime.RequiredError(
                'planSelectionRequest',
                'Required parameter "planSelectionRequest" was null or undefined when calling selectMyPlan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/me/plan-selection`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlanSelectionRequestToJSON(requestParameters['planSelectionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserAccessResponseFromJSON(jsonValue));
    }

    /**
     * Select a self-service access plan for the current user
     */
    async selectMyPlan(requestParameters: SelectMyPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserAccessResponse> {
        const response = await this.selectMyPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
